import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Path } from 'router/constant';

type Props = {
  auth: {
    isAuthenticated: string;
  };
};

export const PrivateWrapper = ({ auth: { isAuthenticated } }: Props) => {
  const location = useLocation();

  if (!isAuthenticated && location.pathname !== Path.ON_BOARDING) {
    localStorage.setItem('navigate_url', location.pathname + location.search);
  } else {
    localStorage.removeItem('navigate_url');
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={Path.LOGIN} />;
};
